// authConfig.js
export const msalConfig = {
  auth: {
    clientId: "4c059cd2-36e4-4e22-a09a-5163c7632186",
    authority: "https://login.microsoftonline.com/4baab2fe-229d-4f1f-b0e8-91d183d6617c",
    redirectUri: "https://portal.boom-h2-pipelines.com",
  },
};
